/**
 * 型安全な REST API クライアント
 * OpenAPI仕様から生成された型を使用
 */
import { fetchAuthSession } from "@aws-amplify/auth";
import createClient from "openapi-fetch";
import type { paths } from "./schema";

// REST API エンドポイント
// TS Backend: /graphql を除去、Python API: そのまま使用
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "";
const REST_API_BASE_URL = API_ENDPOINT.replace(/\/graphql$/, "");

/**
 * 認証トークンを取得
 */
async function getAuthToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    // Cognito User Pool Authorizer requires ID Token (not Access Token)
    return session.tokens?.idToken?.toString() || null;
  } catch (_e) {
    return null;
  }
}

/**
 * 型安全な API クライアント
 * 生成された型を使用して完全な型安全性を提供
 */
export const api = createClient<paths>({
  baseUrl: REST_API_BASE_URL,
});

// リクエストインターセプターで認証ヘッダーを追加
api.use({
  async onRequest({ request }) {
    const token = await getAuthToken();
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }
    return request;
  },
});

/**
 * API エラークラス
 * @param {string} message - エラーメッセージ
 * @param {number} status - HTTPステータスコード
 * @param {unknown} body - レスポンスボディ
 */
export class ApiError extends Error {
  /**
   * ApiErrorのコンストラクタ
   * @param {string} message - エラーメッセージ
   * @param {number} status - HTTPステータスコード
   * @param {unknown} body - レスポンスボディ
   */
  constructor(
    message: string,
    public status: number,
    public body?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

// 型のエクスポート（コンポーネントで使用する場合）
export type { components, paths } from "./schema";
